// src/context/jobPostProgressFrom.jsx
import React, { createContext, useContext, useState, useEffect } from "react";

const getHalfHourLater = () => {
  const now = new Date();

  // Step 1: add 30 minutes
  now.setMinutes(now.getMinutes() + 30);

  // Step 2: round UP to next 00 or 30
  const minutes = now.getMinutes();

  if (minutes > 0 && minutes <= 30) {
    now.setMinutes(30, 0, 0);
  } else {
    now.setHours(now.getHours() + 1);
    now.setMinutes(0, 0, 0);
  }

  let hours = now.getHours();
  const finalMinutes = now.getMinutes();

  const period = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return {
    hour: String(hours).padStart(2, "0"),
    minute: String(finalMinutes).padStart(2, "0"),
    period,
  };
};




const JobPostProgressContext = createContext();
export const useJobPostProgressContext = () =>
  useContext(JobPostProgressContext);

export const JobPostProgressProvider = ({ children, initialData = null }) => {
  const [jobPostProgress, setJobPostProgress] = useState({
    location: { address: "", lat: null, lng: null },
    selectedService: {
      service: "",
      serviceEquipment: [],
      serviceInstruction: "",
    },
    window: '5h',
    scheduledDate: "", // holds just the date (e.g. "2025-09-15")
    scheduledTime: getHalfHourLater(),
    referredBy: "",
    isRequestedForVolunteer: false,
    serviceDuration: "",
    paymentOffering: "",
  });

  useEffect(() => {
    console.log(initialData)
    if (initialData) {
      setJobPostProgress((prev) => ({
        ...prev,
        // location comes as coordinates array → map to lat/lng
        location: initialData.location?.coordinates
          ? {
            address: initialData.location.address || "", // no address from backend
            lat: initialData.location.coordinates[1],
            lng: initialData.location.coordinates[0],
          }
          : prev.location,

        // serviceDetail → selectedService
        selectedService: {
          service: initialData.serviceDetail?.service || "",
          serviceEquipment: initialData.serviceDetail?.serviceEquipment || [],
          // backend sends array for instruction, context expects string
          serviceInstruction: Array.isArray(
            initialData.serviceDetail?.serviceInstruction
          )
            ? initialData.serviceDetail.serviceInstruction.join("\n")
            : initialData.serviceDetail?.serviceInstruction || "",
        },

        window: initialData.window || '5h',

        scheduledDate: initialData.scheduledDate
          ? new Date(initialData.scheduledDate).toISOString().split("T")[0] // store only yyyy-mm-dd
          : "",

        scheduledTime: {
          ...prev.scheduledTime,
          ...initialData.scheduledTime,
        },

        serviceDuration: initialData.completionTime || "",
        isRequestedForVolunteer: !!initialData.isRequestedForVolunteer,
        referredBy: initialData.referredBy || "",

        paymentOffering: initialData.paymentInfo?.amount
          ? initialData.paymentInfo.amount / 100 // convert cents → dollars
          : "",
      }));
    }
  }, [initialData]);

  // --- setters ---

  const setSelectedService = (updates, reset = true) => {
    setJobPostProgress((prevData) => ({
      ...prevData,
      selectedService: {
        ...prevData.selectedService,
        ...updates,
        serviceEquipment:
          updates.serviceEquipment !== undefined
            ? updates.serviceEquipment
            : reset
              ? []
              : prevData.selectedService.serviceEquipment,
        serviceInstruction:
          updates.serviceInstruction !== undefined
            ? updates.serviceInstruction
            : reset
              ? ""
              : prevData.selectedService.serviceInstruction,
      },
    }));
  };

  const setScheduledDate = (date) => {
    setJobPostProgress((prevData) => ({
      ...prevData,
      scheduledDate: date,
    }));
  };

  const setScheduledTime = (hour, minute, period) => {
    setJobPostProgress((prevData) => ({
      ...prevData,
      scheduledTime: { hour, minute, period },
    }));
  };

  const setLocation = (address, lat, lng) => {
    setJobPostProgress((prevData) => ({
      ...prevData,
      location: { address, lat, lng },
    }));
  };

  const setServiceDuration = (duration) => {
    setJobPostProgress((prevData) => ({
      ...prevData,
      serviceDuration: duration,
    }));
  };

  const setPaymentOffering = (offering) => {
    setJobPostProgress((prevData) => ({
      ...prevData,
      paymentOffering: offering,
    }));
  };

  const setIsRequestedForVolunteer = (flag) => {
    setJobPostProgress((prev) => ({
      ...prev,
      isRequestedForVolunteer: flag,
    }));
  };

  const setReferredBy = (referral) => {
    setJobPostProgress((prev) => ({
      ...prev,
      referredBy: referral,
    }));
  };

  const setWindow = (window) => {
    setJobPostProgress((prev) => ({
      ...prev,
      window: window,
    }));
  };

  return (
    <JobPostProgressContext.Provider
      value={{
        jobPostProgress,
        setSelectedService,
        setScheduledDate,
        setScheduledTime,
        setLocation,
        setServiceDuration,
        setPaymentOffering,
        setIsRequestedForVolunteer,
        setReferredBy,
        setWindow
      }}
    >
      {children}
    </JobPostProgressContext.Provider>
  );
};
